// extracted by mini-css-extract-plugin
export var container = "Pagination-module--container--2UvO6";
export var container__items = "Pagination-module--container__items--3uY91";
export var container__button = "Pagination-module--container__button--1jFdz";